import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { initLenis, scrollToSection } from "@/lib/scroll";
import HomePage from "@/pages/HomePage";
import BlogListPage from "@/pages/BlogListPage";
import PublicationsPage from "@/pages/PublicationsPage";
import GeneralPhysicianBhopal from "@/pages/GeneralPhysicianBhopal";
import BlogPostPage from "@/pages/BlogPostPage";
import LegalPage from "@/pages/LegalPage";

const RouteEffects = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const t = setTimeout(() => scrollToSection(id), 150);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  return null;
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <RouteEffects />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/publications" element={<PublicationsPage />} />
          <Route path="/general-physician-bhopal" element={<GeneralPhysicianBhopal />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/privacy-policy" element={<LegalPage pageKey="privacy-policy" />} />
          <Route path="/terms-of-use" element={<LegalPage pageKey="terms-of-use" />} />
          <Route path="/medical-disclaimer" element={<LegalPage pageKey="medical-disclaimer" />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
